module.exports = __webpack_public_path__ + "img/index-5-pic01@2x.dcf11712.png";